import GoalActions from '../../../../actions/GoalActions';

export const actions = {
    getGoalActions(ids) {
        if (!ids.length) {
            return;
        }

        const params = {
            ids: ids.join(',')
        };

        GoalActions.getListGoalActions(params);
    },

    getListCurGoals(list, ids) {
        let newlist = [];

        // if the wound lists, then the search is not needed
        if (ids.length !== list.length) {
            ids.map((id) => {
                newlist.push(list.find((item) => item.id === id) || id);
            });
        } else {
            newlist = list;
        }

        return newlist;
    },
};
